
<template>
  <div class="esigns fontScN8 flexRow">
      <div class="title">请绘制清晰可辨的签名</div>
      <div class="btnBox">
          <div class="clearBtn borderScN4 rowJcAc"  @click="handleReset">
              <img src="../../assets/static/contract/clear.svg" class="clearImg" alt="">
          </div>
          <div class="signOutBtn fontScN7 fontH2 rowJcAc borderScN4" @click="clickSignOut">退出签名</div>
          <div class="useBtn fontScW fontH2 rowJcAc bgcMcA1" @click="handleGenerate">使用签名</div>
      </div>
           <vue-esign
            ref="esign"
            style="
                width: 90% !important;
                height: 100% !important;
                margin-left: 0.64rem;
            "
            :isCrop="isCrop"
            :lineWidth="lineWidth"
            :lineColor="lineColor"
            :bgColor.sync="bgColor"
            :height="height"
            :width="width"
            />
   
  </div>
</template>

<script>
import { postSignatureAPI} from "../../utils/api/contractAPI";
import { postTaskUploadFile } from "../../utils/api/taskApi";
export default {
  name: "Esign",
  data() {
    return {
      lineWidth: 6,//画笔宽度
      lineColor: "#191C27",//画笔颜色
      bgColor: "",//背景颜色
      isCrop: false,//裁剪
      height:document.body.offsetHeight,//画布高度
      width:document.body.offsetWidth*(0.9),//画布宽度
      parentUid:'',//客户id
      campusCode:'',//校区code
      imageUrl:'',//后端返回的签名地址
    };
  },
  created() {　　
    this.getCampusInfo()
    },

  methods: {
    // 清除
    handleReset() { 
      this.$refs.esign.reset();
    },
    //点击使用签名
    handleGenerate() {
      // 获取base64
      var _this = this;
      _this.$refs.esign
        .generate()
        .then((res) => {
          // 转成文件
          var file = _this.dataURLtoFile(res);
            // console.log("file----------:",res,file )
            var formData = new FormData();
            formData.append("file", file);
            formData.append("application", 'xk-wx')
            formData.append("type", 2) // 1.系统文件 2.应用文件
              postTaskUploadFile(formData).then((res) => {
                if (res.resultCode == 200) {
                  var obj = {
                    customerId:_this.parentUid,
                    imageUrl:res.data
                  }
                  this.imageUrl = res.data
                  postSignatureAPI(obj).then(res => {
                      if(res.resultCode == 200) {
                          console.log('使用签名成功')
                          this.$common.setCache('url',this.imageUrl+'?x-oss-process=image/rotate,270')

                          this.$router.back()
                      }
                  })

                } else {
                  _this.$toast(res.resultStr);
                }
              });
        })
        .catch((err) => {
          _this.$toast(err); 
        });
    },
    // 将base64转换为file
    dataURLtoFile(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bytes = atob(arr[1]); // 解码base64
      let n = bytes.length;
      let ia = new Uint8Array(n);
      while (n--) {
        ia[n] = bytes.charCodeAt(n);
      }
      return new File([ia], "easign.jpg", { type: mime });
    },
    //点击退出签名
    clickSignOut(){
      this.$router.back()
      // this.$router.push({
      //       name: "SignContract",
      //       // params: { submit: true },
      //   });
    },
    // 获取校区信息
    getCampusInfo() {
        if(this.$common.getCache('campusItem')) { // 判断本地有无校区信息
            var campusItem = JSON.parse(this.$common.getCache('campusItem'))
            this.parentUid = campusItem.customerId
            this.campusCode = campusItem.campusCode
        }else {
            var campusList = JSON.parse(this.$common.getCache('customerAuthList'))
            if(campusList) {
                this.campusCode = campusList[0].campusCode
                this.parentUid = campusList[0].customerId
            }
        }
        
    },

  },
};
</script>

<style lang="scss" scoped>
.esigns{
    width: 100%;
    height: 100%;
}
.btn {
  display: flex;
  justify-content: space-around;
  margin-top: 10px;
}
.clearImg{
    width: 0.24rem;
    height: 0.24rem;
}
.clearBtn{
    width: 0.44rem;  
    position: fixed;
    left: 0.16rem;
    bottom: 3.91rem;     
}
.signOutBtn{
    width: 1.64rem;
    height: 0.44rem;
    transform: rotate(90deg);
    position: fixed;
    left: -0.44rem;
    bottom: 2.68rem;
}
.useBtn{
    width: 1.64rem;
    height: 0.44rem;
    box-sizing: border-box;
    border-radius: 0.06rem;
    transform: rotate(90deg);
    position: fixed;
    left: -0.44rem;
    bottom: 0.84rem;
}
.clearBtn,.signOutBtn{
    height: 0.44rem;
    border-width: 1px;
    border-style: solid;
    box-sizing: border-box;
    border-radius: 0.06rem;
}
.title{
    transform: rotate(90deg);
    position: fixed;
    right: -0.54rem;
    bottom: 50%;
}
.drawingBox{
    width: 100%;
    height: 100%;
}
.rrr{
  width: 100px;
  height: 100px;
}
.btnBox{
  width: 0.6rem;
  height: 100%;
}
</style>
